import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const LoginParams = () => {
    const params = useParams()

    useEffect(() => {

        if (params.prop === "email-verification-success") {
            handleLogout()
            toast.success('ایمیل شما با موفقیت تایید شد.')
        }
        if (params.prop === "reset-password-success") {
            handleLogout()
            toast.success('گذرواژه شما با موفقیت بازنشانی شد و به آدرس ایمیل شما ارسال گردید.')
        }
        if (params.prop === "reset-password-failure") {
            handleLogout()
            toast.error('لینک نامعتبر می باشد. لطفا یکبار دیگر تلاش نمایید و در صورت برخورد مجدد با این خطا با پشتیبانی تماس بگیرید.')
        }
        if (params.prop === "email-verification-failure") {
            handleLogout()
            toast.error('ایمیل شما قبلا تائید شده است')
        }
        if (params.prop === "email-verification-repeat") {
            handleLogout()
            toast.error('لینک نامعتبر می باشد. لطفا یکبار دیگر تلاش نمایید و در صورت برخورد مجدد با این خطا با پشتیبانی تماس بگیرید.')
        }

    }, [])

    const handleLogout = () => {
        localStorage.removeItem("dsTokenExpiration")
        localStorage.removeItem("token")
        localStorage.removeItem("portalExtraInfo")
        setTimeout(() => {

        }, 1000);
    }

    return null
}

export default LoginParams